import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import { get } from 'lodash'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { notification, modal, logError } from 'redux/modules/app'
import { tasks as tasksApi, awards as awardsApi } from 'redux/modules/api'

function decorator(config = {}) {
  return ComposedComponent => {
    const enhance = compose(
      connect(
        ({ api, auth, app }) => ({
          local: {
            awards: api.awards
          },
          user: auth.user,
          activeOrganizationId: auth.organization.id,
          tasksAssessors: api.tasks.assessors,
          commonLimit: app.commonLimit
        }),
        {
          ...tasksApi.assessors,
          getTasksOverview: tasksApi.overview.getTasksOverview,
          getAward: awardsApi.getAward,
          getAwards: awardsApi.getAwards,
          notification,
          modal,
          logError
        }
      )
    )

    class TasksAssessors extends Component {
      static propTypes = {
        decoFilter: PropTypes.string,
        user: PropTypes.object.isRequired,
        activeOrganizationId: PropTypes.number.isRequired,
        getTasksOverview: PropTypes.func.isRequired,
        logError: PropTypes.func.isRequired,
        modal: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        approveAssessorRegistration: PropTypes.func,
        approveActivityCategoryRegistration: PropTypes.func,
        setAssessorTasksParams: PropTypes.func,
        tasksAssessors: PropTypes.object.isRequired,
        getTasksAssessors: PropTypes.func,
        getAssessorActivityCategoryRegistrationApprovalTasks: PropTypes.func,
        deleteAssessorRegistration: PropTypes.func,
        updateAssessorRegistration: PropTypes.func,
        updateActivityRegistration: PropTypes.func,
        deleteActivityRegistration: PropTypes.func,
        decoUpdateOrganizationOverview: PropTypes.bool,
        commonLimit: PropTypes.number
      }

      componentDidMount() {
        const { commonLimit, setAssessorTasksParams, tasksAssessors } = this.props

        if (config.useCommonLimit && commonLimit) {
          config.assessorTasks && setAssessorTasksParams({ limit: commonLimit })
        } else {
          config.assessorTasks && this.handleGetTasksAssessors(tasksAssessors)
        }

        config.assessorActivityCategoryTasks && this.handleGetActivityCategoryRegistrationApprovalTasks(tasksAssessors)
      }

      componentWillReceiveProps(nextProps) {
        const { tasksAssessors } = this.props
        const { filter, limit, offset, sort, invalidate } = nextProps.tasksAssessors

        if (
          tasksAssessors.filter !== filter ||
          tasksAssessors.limit !== limit ||
          tasksAssessors.offset !== offset ||
          tasksAssessors.sort !== sort ||
          tasksAssessors.invalidate !== invalidate
        ) {
          this.handleGetTasksAssessors(nextProps.tasksAssessors)
          this.handleGetActivityCategoryRegistrationApprovalTasks(tasksAssessors)
        }
      }

      handleGetBaseFilter = () => {
        const { params, decoFilter } = this.props

        switch (decoFilter || config.filter) {
          case 'awardUnitRegistrations':
            return `organization.id=${params && params.id}`
          default:
            return ''
        }
      }

      handleGetTasksAssessors = tasks =>
        this.props.getTasksAssessors(tasks, this.handleGetBaseFilter())

      handleApproveAssessorRegistration = assessorId =>
        this.props.approveAssessorRegistration(assessorId, { approved: true })
          .then(this.handleSuccess)
          .catch(this.handleError)

      handleGetActivityCategoryRegistrationApprovalTasks = tasks =>
          this.props.getAssessorActivityCategoryRegistrationApprovalTasks(tasks, this.handleGetBaseFilter())

      handleApproveActivityCategoryRegistration = id =>
          this.props.approveActivityCategoryRegistration(id, { approved: true })
              .then(this.handleActivityRegistrationSuccess)
              .catch(this.handleError)

      handleReturnAssessorRegistration = (assessorId, fields = {}) =>
        this.props
          .approveAssessorRegistration(assessorId, {
            approved: false,
            note: fields.note
          })
          .then(() => {
            this.handleSuccess({
              label: 'Assessor revised',
              intlKey: 'notifications.assessor_has_been_revised'
            })
          })
          .catch(this.handleError)

      onReturnActivityCategoryRegistration = (id, fields = {}) =>
          this.props.approveAssessorRegistration(id, { approved: false, note: fields.note })
              .then(() => {
                this.handleActivityRegistrationSuccess({
                  label: 'Registration has been revised.',
                  intlKey: 'notifications.registration_has_been_revised'
                })
              })
              .catch(this.handleError)

      handleDeleteAssessorRegistration = (id, fields) => {
        return this.props.deleteAssessorRegistration(id, { reason: fields.reason })
            .then(() => {
              this.handleSuccess({
                label: 'Assessor registration has been deleted.',
                intlKey: 'notifications.assessor_registration_has_been_deleted'
              })
            })
            .catch(this.handleError)
      }

      handleUpdateAssessorRegistration = (id, data) => {
        return this.props.updateAssessorRegistration(id, data)
            .then(() => {
              this.handleSuccess({
                label: 'Assessor registration has been updated.',
                intlKey: 'notifications.assessor_registration_has_been_updated'
              })
            })
            .catch(this.handleError)
      }

      handleUpdateActivityRegistration = (id, data) => {
        return this.props.updateActivityRegistration(id, data)
            .then(() => {
              this.handleActivityRegistrationSuccess({
                label: 'Activity registration has been updated.',
                intlKey: 'notifications.activity_registration_has_been_updated'
              })
            })
            .catch(this.handleError)
      }

      handleDeleteActivityRegistration = (id, data) => {
        return this.props.deleteActivityRegistration(id, data)
            .then(() => {
              this.handleActivityRegistrationSuccess({
                label: 'Activity registration has been deleted.',
                intlKey: 'notifications.activity_registration_has_been_deleted'
              })
            })
            .catch(this.handleError)
      }

      handleSuccess = (
        {
          label = 'Assessor approved',
          intlKey = 'notifications.assessor_has_been_approved'
        } = {}
      ) => {
        const { tasksAssessors } = this.props

        this.props.notification(label, {
          status: 'success',
          intlKey
        })

        this.handleRefresh(tasksAssessors)
      }

      handleActivityRegistrationSuccess = (
          { label = 'Activity registration has been approved.',
            intlKey = 'notifications.activity_registration_has_been_approved'
          } = {}
      ) => {
        const { tasksAssessors } = this.props

        this.props.notification(label, {
          status: 'success',
          intlKey
        })

        this.handleRefreshActivityRegistrations(tasksAssessors)
      }

      handleRefresh = tasksAssessors => {
        const { decoUpdateOrganizationOverview, params } = this.props

        let id = null

        if (decoUpdateOrganizationOverview) {
          id = params.id
        }

        if (config.updateTasks) {
          this.handleGetTasksAssessors(tasksAssessors)
          this.props.getTasksOverview(null, {
            orgId: id,
            activeOrganizationId: this.props.activeOrganizationId,
            awardLeaderId: this.props.user.personId
          })
          this.props.modal(null)
        }
      }

      handleRefreshActivityRegistrations = tasksAssessors => {
        const { decoUpdateOrganizationOverview, params } = this.props

        let id = null

        if (decoUpdateOrganizationOverview) {
          id = params.id
        }

        if (config.updateTasks) {
          this.handleGetActivityCategoryRegistrationApprovalTasks(tasksAssessors)
          this.props.getTasksOverview(null, {
            orgId: id,
            activeOrganizationId: this.props.activeOrganizationId,
            awardLeaderId: this.props.user.personId
          })
          this.props.modal(null)
        }
      }

      handleError = err => {
        console.debug('error', err.body && err.body.userMessage)
        this.props.logError(err)
      }

      render() {
        return (
          <ComposedComponent
            onApproveAssessorRegistration={this.handleApproveAssessorRegistration}
            onReturnAssessorRegistration={this.handleReturnAssessorRegistration}
            onGetActivityCategoryRegistrationApprovalTasks={this.handleGetActivityCategoryRegistrationApprovalTasks}
            onApproveActivityCategoryRegistration={this.handleApproveActivityCategoryRegistration}
            onReturnActivityCategoryRegistration={this.onReturnActivityCategoryRegistration}
            onDeleteAssessorRegistration={this.handleDeleteAssessorRegistration}
            onUpdateAssessorRegistration={this.handleUpdateAssessorRegistration}
            onUpdateActivityRegistration={this.handleUpdateActivityRegistration}
            onDeleteActivityRegistration={this.handleDeleteActivityRegistration}
            {...this.props}
          />
        )
      }
    }
    return enhance(TasksAssessors)
  }
}

export default decorator
